export default __webpack_public_path__ + "static/media/android-guide2.2e1ca8ff.png";